import React, { useEffect, useState } from "react";
import { Fragment } from "react";
import { Button, Col, Form, ListGroup, Modal, Row } from "react-bootstrap";
import { get, post } from "../../../helpers/api_helper";
import {
  GET_GetNDTCategoryTypes,
  POST_GetNDTCategoryByID,
  POST_GetNDTCategoryListByCategoryType,
  POST_NDTCategoryDelete,
  POST_NDTCategoryExport,
  POST_NDTCategoryInsert,
  POST_NDTCategoryStatusUpdate,
  POST_NDTCategoryUpdate,
} from "../../../helpers/url_helper";
import * as Yup from "yup";
import { Field, FormikProvider, useFormik } from "formik";
import { Link } from "react-router-dom";
import CustomSizePerPage from "../../../CustomControls/CustomSizePerPage";
import CustomPaginationButtons from "../../../CustomControls/CustomPaginationButtons";
import { SVGICON } from "../../../constant/theme";
import {
  ActiveInactive_Record,
  capitalizeString,
  delete_Record,
  errorMessage,
  successMessage,
} from "../CommonFunctions";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomSelect from "../../../CustomControls/CustomSelect";
import { Spin } from "antd";
import CustomTextArea from "../../../CustomControls/CustomTextArea";

const NDTCategory = () => {
  const [showFilter, setShowFilter] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentSizePerPage, setCurrentSizePerPage] = useState(10);
  const [recordCount, setRecordCount] = useState(0);
  const [sortBy, setSortBy] = useState("");
  const [orderBy, setOrderBy] = useState("asc");
  const [ndtCategoryTypeList, setNDTCategoryTypeList] = useState([]);
  const [ndtCategoryList, setNDTCategoryList] = useState([]);
  const [ndtCategoryType, setNDTCategoryType] = useState(1);
  const [ndtCategoryTypeName, setNDTCategoryTypeName] = useState("Sensitivity");
  const [categoryModal, setCategoryModal] = useState(false);
  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;
  
  const handleClickSorting = (columnName) => {
    if (sortBy == columnName) {
      if (orderBy == "asc") {
        setOrderBy("desc");
      } else {
        setSortBy("");
        setOrderBy("asc");
      }
    } else {
      setSortBy(columnName);
      setOrderBy("asc");
    }
  };

  const statusOptions = [
    { label: "All", value: -1 },
    { label: "Active", value: 1 },
    { label: "Inactive", value: 0 },
  ];

  const validationSchemaFilter = Yup.object().shape({});

  const formikFilter = useFormik({
    validationSchemaFilter,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitFilter(values, formikHelpers),
    initialValues: {
      Search: "",
      Status: -1,
    },
    validateOnBlur: false,
  });

  const {
    handleValidSubmitFilter,
    values: { Search, Status },
  } = formikFilter;

  const get_CategoryTypes = async () => {
    setIsLoading(true);
    await get(GET_GetNDTCategoryTypes)
      .then((response) => {
        if (response?.IsSuccess) {
          setNDTCategoryTypeList(response?.List);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    get_CategoryTypes();
  }, []);

  useEffect(() => {
    getData(1, currentSizePerPage);
  }, [sortBy, orderBy]);

  useEffect(() => {
    formikFilter.resetForm();
    if (sortBy != "") {
      setSortBy("");
    } else {
      getData();
    }
  }, [ndtCategoryType]);

  const getData = async (page = 1, sizePerPage = 10) => {
    setIsLoading(true);

    let payload = {
      CurrentPage: page,
      PageSize: sizePerPage,
      Search: Search,
      Sorting: sortBy ? sortBy + " " + orderBy : "",
      Status: Status,
      NDTCategoryType: ndtCategoryType,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    };

    await post(POST_GetNDTCategoryListByCategoryType, payload)
      .then((response) => {
        setRecordCount(response?.TotalRecordCount);
        setNDTCategoryList(response?.List);
        setIsLoading(false);

        if (page > 1 && response?.List?.length === 0) {
          setCurrentPage(page - 1);
          getData(page - 1, sizePerPage);
        } else {
          setCurrentPage(page);
        }
        setCurrentSizePerPage(sizePerPage);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const fnCallback = () => {
    getData(currentPage, currentSizePerPage);
  };

  const exportReport = () => {
    setIsLoading(true);
    let payload = {
      Search: Search,
      Status: Status,
      NDTCategoryType: ndtCategoryType,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    };
    post(POST_NDTCategoryExport, payload)
      .then((response) => {
        if (response?.IsSuccess) {
          window.open(response?.FilePath);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const validationSchema = Yup.object().shape({
    NDTCategoryType: Yup.number(),
    NDTCategoryName: Yup.string()
      .trim()
      .required(`${ndtCategoryTypeName} is required field`),
  });

  const formik = useFormik({
    validationSchema: validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      NDTCategoryIDEncrypted: "",
      NDTCategoryType: ndtCategoryType,
      NDTCategoryName: "",
      Description: "",
    },
    validateOnBlur: false,
  });

  const {
    values: { Description },
  } = formik;

  const handleValidSubmit = (values) => {
    setIsLoading(true);
    let payload = {
      NDTCategoryIDEncrypted: values.NDTCategoryIDEncrypted
        ? values.NDTCategoryIDEncrypted
        : 0,
      NDTCategoryType: ndtCategoryType,
      NDTCategoryName: values.NDTCategoryName.trim(),
      Description: values.Description.trim(),
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
      ModifiedByEncrypted: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
    };
    post(
      values.NDTCategoryIDEncrypted
        ? POST_NDTCategoryUpdate
        : POST_NDTCategoryInsert,
      payload
    )
      .then((response) => {
        setIsLoading(true);
        if (response.IsSuccess) {
          successMessage(response?.Message);
          formik.resetForm();
          getData(1, currentSizePerPage);
          if (values.NDTCategoryIDEncrypted) {
            setCategoryModal(false);
          }
        } else {
          errorMessage(response?.Message);
          setIsLoading(false);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  function add_category() {
    formik.resetForm();
    formik.setFieldValue("NDTCategoryType", ndtCategoryType);
    setCategoryModal(true);
    //inputRef.current.focus();
  }

  const get_CategoryByID = async (ID) => {
    setIsLoading(true);
    await post(POST_GetNDTCategoryByID, {
      NDTCategoryIDEncrypted: ID,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.resetForm();
          formik.setValues({
            NDTCategoryIDEncrypted: ID,
            NDTCategoryType: ndtCategoryType,
            NDTCategoryName: response?.NDTCategoryName,
            Description: response?.Description || "",
          });
          setCategoryModal(true);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="table-responsive active-projects style-1 shorting">
            <div className="tbl-caption p-2">
              <h4 className="heading mb-0">NDT Categories</h4>
              <div className="d-flex align-items-center">
                <button
                  type="button"
                  className="btn btn-outline-primary btn-sm me-2"
                  onClick={(e) => {
                    getData();
                  }}
                >
                  <i className="fa-solid fa-refresh me-2"></i>Reload
                </button>
                <button
                  type="button"
                  className="btn btn-outline-primary btn-sm me-2"
                  onClick={() => setShowFilter(!showFilter)}
                >
                  <i className="fa-solid fa-filter me-2"></i>Filter
                </button>
                {AuthUser?.UserType !== 1 ||
                formsList?.filter((x) => x?.FormID == 94 && x?.IsExport)
                  ?.length > 0 ? (
                  <Link
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={exportReport}
                  >
                    <i className="fa-solid fa-file-excel" /> Export Report
                  </Link>
                ) : (
                  ""
                )}
                {AuthUser?.UserType !== 1 ||
                formsList?.filter((x) => x?.FormID == 94 && x?.IsAdd)?.length >
                  0 ? (
                  <Link
                    to="#"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={() => add_category()}
                  >
                    <i className="fa-solid fa-plus"></i> Add{" "}
                    {ndtCategoryTypeName}
                  </Link>
                ) : (
                  ""
                )}
              </div>
            </div>
            <hr className="mt-0 mb-1"></hr>
            <div className="p-2 pt-0">
              <Row className="ps-1 me-0">
                <Col lg={2} className="p-1">
                  <div className="basic-list-group">
                    <ListGroup as="ul" style={{ borderRadius: "0" }}>
                      {ndtCategoryTypeList?.map((list, i) => (
                        <Fragment key={i}>
                          <ListGroup.Item
                            as="li"
                            style={{
                              cursor: "pointer",
                              padding: "0.67rem 1rem",
                            }}
                            className={
                              list.NDTCategoryType === ndtCategoryType
                                ? "active"
                                : ""
                            }
                            onClick={() => {
                              setNDTCategoryTypeName(list.NDTCategoryName);
                              setNDTCategoryType(list.NDTCategoryType);
                              formik.setFieldValue(
                                "NDTCategoryType",
                                list.NDTCategoryType
                              );
                              formikFilter.setValues({
                                Status: -1,
                                Search: "",
                              });
                            }}
                          >
                            {list.NDTCategoryName}
                          </ListGroup.Item>
                        </Fragment>
                      ))}
                    </ListGroup>
                  </div>
                </Col>
                <Col lg={10} className="p-1">
                  {showFilter ? (
                    <div>
                      <FormikProvider value={formikFilter}>
                        <Form onSubmit={formikFilter.handleSubmit}>
                          <Row className="me-0">
                            <Col lg={3}>
                              <Field
                                label="Search"
                                name="Search"
                                placeholder={"Search here..."}
                                component={CustomInput}
                              />
                            </Col>
                            <Col lg={3}>
                              <Field
                                label="Status"
                                name="Status"
                                placeholder={"Select Status"}
                                options={statusOptions}
                                component={CustomSelect}
                                isClearable={false}
                              />
                            </Col>
                            <Col lg={3}>
                              <label className="mb-1">&nbsp;</label>
                              <div className="d-flex">
                                <div className="d-lg-block">
                                  <Link
                                    // className="btn btn-primary btn-sm mb-1"
                                    className="btn btn-primary btn-sm"
                                    onClick={(e) => {
                                      getData();
                                    }}
                                  >
                                    <i
                                      className="fa fa-search"
                                      aria-hidden="true"
                                    ></i>{" "}
                                    Search
                                  </Link>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </Form>
                      </FormikProvider>
                    </div>
                  ) : (
                    ""
                  )}
                  <div
                    id="NDTCategories-tbl_wrapper"
                    className="dataTables_wrapper no-footer"
                  >
                    <table
                      id="projects-tbl"
                      className="table dataTable no-footer mb-0"
                    >
                      <thead>
                        <tr>
                          <th width="6%"></th>
                          <th
                            style={{
                              width: ndtCategoryType == 5 ? "40%" : "94%",
                              textAlign: "left",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleClickSorting("NDTCategoryName");
                            }}
                          >
                            {ndtCategoryTypeName}
                            <span className="ml-1">
                              {sortBy == "NDTCategoryName" ? (
                                orderBy == "desc" ? (
                                  <i
                                    className="fa fa-arrow-down ms-2 fs-14"
                                    style={{ opacity: "0.7" }}
                                  />
                                ) : (
                                  <i
                                    className="fa fa-arrow-up ms-2 fs-14"
                                    style={{ opacity: "0.7" }}
                                  />
                                )
                              ) : (
                                <i
                                  className="fa fa-sort ms-2 fs-14"
                                  style={{ opacity: "0.3" }}
                                />
                              )}
                            </span>
                          </th>
                          {ndtCategoryType == 5 && (
                            <th
                              style={{
                                width: "54%",
                                cursor: "pointer",
                                textAlign: "left",
                              }}
                              onClick={() => {
                                handleClickSorting("Description");
                              }}
                            >
                              Description{" "}
                              <span className="ml-1">
                                {sortBy == "Description" ? (
                                  orderBy == "desc" ? (
                                    <i
                                      className="fa fa-arrow-down ms-2 fs-14"
                                      style={{ opacity: "0.7" }}
                                    />
                                  ) : (
                                    <i
                                      className="fa fa-arrow-up ms-2 fs-14"
                                      style={{ opacity: "0.7" }}
                                    />
                                  )
                                ) : (
                                  <i
                                    className="fa fa-sort ms-2 fs-14"
                                    style={{ opacity: "0.3" }}
                                  />
                                )}
                              </span>
                            </th>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {ndtCategoryList?.length > 0 ? (
                          ndtCategoryList?.map((item, indx) => (
                            <tr key={indx}>
                              <td>
                                {AuthUser?.UserType !== 1 ||
                                formsList?.filter(
                                  (x) => x?.FormID == 94 && x?.IsEdit
                                )?.length > 0 ? (
                                  <Link
                                    to="#"
                                    className="icon-box icon-box-md me-1"
                                    title="Edit"
                                    onClick={() =>
                                      get_CategoryByID(
                                        item.NDTCategoryIDEncrypted
                                      )
                                    }
                                  >
                                    {SVGICON.EditPrimary}
                                  </Link>
                                ) : (
                                  ""
                                )}

                                {AuthUser?.UserType !== 1 ||
                                formsList?.filter(
                                  (x) => x?.FormID == 94 && x?.IsActive
                                )?.length > 0 ? (
                                  <Link
                                    to="#"
                                    className={`icon-box icon-box-md me-1`}
                                    title={
                                      item.IsActive == true
                                        ? "Active"
                                        : "Inactive"
                                    }
                                    onClick={() => {
                                      ActiveInactive_Record(
                                        item.IsActive,
                                        POST_NDTCategoryStatusUpdate,
                                        {
                                          NDTCategoryIDEncrypted:
                                            item.NDTCategoryIDEncrypted,
                                          IsActive: !item.IsActive,
                                          ModifiedByEncrypted:
                                            AuthUser?.ReferenceIDEncrypt
                                              ? AuthUser?.ReferenceIDEncrypt
                                              : "0",
                                        },
                                        setIsLoading,
                                        fnCallback,
                                        item.NDTCategoryName
                                      );
                                    }}
                                  >
                                    <i
                                      className={`fa fa-circle fs-15 ${
                                        item.IsActive == true
                                          ? "text-success"
                                          : "text-danger"
                                      }`}
                                    ></i>
                                  </Link>
                                ) : (
                                  ""
                                )}
                                {AuthUser?.UserType !== 1 ||
                                formsList?.filter(
                                  (x) => x?.FormID == 94 && x?.IsDelete
                                )?.length > 0 ? (
                                  <Link
                                    to="#"
                                    className="icon-box icon-box-md me-1"
                                    title="Delete"
                                    onClick={() => {
                                      delete_Record(
                                        POST_NDTCategoryDelete,
                                        {
                                          NDTCategoryIDEncrypted:
                                            item.NDTCategoryIDEncrypted,
                                          ModifiedByEncrypted:
                                            AuthUser?.ReferenceIDEncrypt
                                              ? AuthUser?.ReferenceIDEncrypt
                                              : "0",
                                        },
                                        setIsLoading,
                                        fnCallback,
                                        item.NDTCategoryName
                                      );
                                    }}
                                  >
                                    {SVGICON.DeleteDanger}
                                  </Link>
                                ) : (
                                  ""
                                )}
                              </td>
                              <td
                                style={{
                                  textAlign: "left",
                                  verticalAlign: "top",
                                  whiteSpace: "normal",
                                }}
                              >
                                {item.NDTCategoryName}
                              </td>
                              {ndtCategoryType == 5 && (
                                <td style={{ textAlign: "left" }}>
                                  {item.Description}
                                </td>
                              )}
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={3} style={{ textAlign: "left" }}>
                              <div>{"No Record Found..."}</div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>

                    <div className="d-sm-flex text-center justify-content-between align-items-center">
                      <CustomSizePerPage
                        getData={getData}
                        currentSizePerPage={currentSizePerPage}
                      />
                      <div className="dataTables_info">
                        Showing{" "}
                        {recordCount > 0
                          ? (currentPage - 1) * currentSizePerPage + 1
                          : 0}{" "}
                        to{" "}
                        {recordCount > currentPage * currentSizePerPage
                          ? currentPage * currentSizePerPage
                          : recordCount}{" "}
                        of {recordCount} entries
                      </div>
                      <CustomPaginationButtons
                        totalPages={recordCount / currentSizePerPage}
                        currentPage={currentPage}
                        currentSizePerPage={currentSizePerPage}
                        getData={getData}
                      />
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Spin>
        <Modal className="fade" show={categoryModal} onHide={setCategoryModal}>
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>{ndtCategoryTypeName}</Modal.Title>
                  <Button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setCategoryModal(false)}
                  ></Button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={12}>
                      <Field
                        type="text"
                        label={ndtCategoryTypeName}
                        name="NDTCategoryName"
                        placeholder={`Enter ${ndtCategoryTypeName}`}
                        component={CustomInput}
                        maxLength={250}
                        required
                        autoFocus
                        onChange={(e) => {
                          formik.setFieldValue(
                            "NDTCategoryName",
                            capitalizeString(e)
                          );
                        }}
                      />
                    </Col>
                    {ndtCategoryType == 5 && (
                      <Col lg={12}>
                        <Field
                          type="text"
                          label="Description"
                          name="Description"
                          placeholder={"Enter Description"}
                          component={CustomTextArea}
                          maxLength={500}
                          rows={5}
                        />
                      </Col>
                    )}
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="primary btn-sm" type="submit">
                    <i className="fa-solid fa-floppy-disk"></i> Submit
                  </Button>
                  <Button
                    variant="danger btn-sm"
                    onClick={() => setCategoryModal(false)}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </Button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal>
      </div>
    </div>
  );
};

export default NDTCategory;
